import { buildCssVar } from 'utils/style-override';

import styles from './styles.module.scss';

export default function CheckoutErrorModal({
  title,
  message,
  handleViewOrderSummary,
  isViewOrderSummaryDisabled,
}: {
  title?: string;
  message: string;
  handleViewOrderSummary: () => void;
  isViewOrderSummaryDisabled: boolean;
}) {
  return (
    <div className={styles.modal}>
      <style jsx global>{`
        body {
          overflow: hidden;
        }
        #sticky-banner {
          z-index: 1;
        }
        .root {
          ${buildCssVar('--button-color', '#8f8e8d')}
        }
      `}</style>
      <div className={styles.modal_content}>
        {title && <p>{title}</p>}
        <p className={styles.invalid_msg}>{message}</p>
        <div className={styles.modal_btn}>
          <button
            className={styles.btn}
            onClick={handleViewOrderSummary}
            disabled={isViewOrderSummaryDisabled}
          >
            View order summary
          </button>
        </div>
      </div>
    </div>
  );
}
